@layer module {
.empty-state {
            display: flex;
            flex: 1 1 auto;
            flex-direction: column;
            align-items: center;
            justify-content: safe center;
            min-height: 0;
            text-align: center;
    }

.empty-state__icon {
            position: relative;
            display: grid;
            place-items: center;
    }

.empty-state__dot {
            position: absolute;
    }
} // layer module










@layer app {
.empty-state {
            padding: $size-32 $size-20;
            gap: $size-12;
    }

.empty-state__icon {
            width: $size-110;
            height: $size-100;
            margin-bottom: $size-8;
            border-radius: $size-24;
    }

.empty-state__dot {
            top: $size-neg-6;
            right: $size-neg-6;
            width: $size-20;
            height: $size-20;
            border-radius: 50%;
    }

.empty-state__title {
            margin: 0;
    }

.empty-state__message {
            max-width: $size-440;
            margin: 0;
    }

.empty-state__icon {
            background: var(--color-brand-wash);
            color: var(--color-brand);
    }

.empty-state__dot {
            background: var(--color-action);
    }

.empty-state__title {
            color: var(--text-primary);
            font-size: var(--font-size-lg);
            font-weight: 600;
    }

.empty-state__message {
            color: var(--text-secondary);
            font-size: var(--font-size-base);
    }
} // layer app
